export class StorageService {
  private static FEATURE_LOGGING_COOKIE_NAME = "featureLogging";

  private static INSTANCE: StorageService = new StorageService();

  public static instance(): StorageService {
    return StorageService.INSTANCE;
  }

  public getCookieValue(cookiename: string): string {
    const re = new RegExp("[; ]" + cookiename + "=([^\\s;]*)");
    const sMatch: RegExpMatchArray | null = (" " + document.cookie).match(re);
    if (cookiename && sMatch) {
      return unescape(sMatch[1]);
    }
    return "";
  }

  public hasCookie(cookiename: string): boolean {
    return document.cookie.indexOf(cookiename + "=") !== -1;
  }

  public getFeatureLoggingState(): string {
    return this.getCookieValue(StorageService.FEATURE_LOGGING_COOKIE_NAME);
  }
}
